// Copyright (c) Docugami, Inc. All rights reserved.

import { Icon, IDropdownOption, IIconProps, Stack } from "@fluentui/react";
import { ExplorerStatusItemLabel } from "components/common/Fonts";
import { FileStatusCategory, getStatusCategoryLabel, getStatusIcon } from "filemanager/FileStatus";
import { IDocumentsFilters } from "hooks/GetDocumentsFilters";
import { CommandBarDropdown, IFilterOption } from "./ExplorerCommandBarDropdown";
import { ExplorerFilterCommandBar } from "./ExplorerFilterCommandBar";

interface DocsetFiltersCommandBarProps extends IDocumentsFilters {
    hidden?: boolean;
    onDismiss: () => void;
}

export const DocsetFiltersCommandBar = (props: DocsetFiltersCommandBarProps) => {
    const { statuses, addStatus, clearFilters, setFilename } = props;

    function onStatusChange(ev: React.FormEvent<HTMLDivElement>, option: IDropdownOption<any> | undefined) {
        if (option?.key) {
            const key = option.key as FileStatusCategory;
            addStatus(key, !!option.selected);
        }
    }

    function dismissFilters() {
        clearFilters();
        props.onDismiss();
    }

    return (
        <ExplorerFilterCommandBar hidden={!!props.hidden} onDismiss={dismissFilters} searchProps={{ searchPlaceholder: "Filter by name", onSearch: setFilename }}>
            <CommandBarDropdown
                label="Status"
                multiSelect
                options={statuses.map(getStatusOption)}
                onChange={onStatusChange}
                onRenderOption={renderStatusOption} />
        </ExplorerFilterCommandBar>
    )
}

function getStatusOption(status: FileStatusCategory): IFilterOption {
    return {
        key: status,
        text: getStatusCategoryLabel(status),
        data: { icon: getStatusIcon(status) }
    }
}

function renderStatusOption(option?: IFilterOption, defaultRender?: (props?: IFilterOption) => JSX.Element | null) {
    if (!option) {
        return null;
    }

    return (
        <Stack horizontal tokens={{ childrenGap: '5px', padding: '5px' }}>
            {option.data && option.data.icon && (
                <Icon {...option.data.icon as IIconProps} styles={{ root: { color: option.data.icon.color } }} />
            )}
            <ExplorerStatusItemLabel>{defaultRender?.(option)}</ExplorerStatusItemLabel>
        </Stack>
    );
}